import { Button } from "@/components/ui/button";
import { Trophy, CheckCircle } from "lucide-react";

export function MatchCard({ match, eventStatus, onRecordResult, onOpenScoreDialog, isContinuous, onContinue }) {
  const isComplete = match.status === "completed";
  const team1Won = match.winner_team_id === match.team1_id;
  const team2Won = match.winner_team_id === match.team2_id;

  return (
    <div className={`border p-5 transition-colors duration-200 ${isComplete ? "border-[#309F6A]/30 bg-[#309F6A]/5" : "border-white/10 bg-[#141414]"}`} data-testid={`${isContinuous ? "cont-" : ""}match-card-board-${match.board_number}`}>
      <div className="flex items-center justify-between mb-4">
        <p className="text-xs tracking-[0.2em] uppercase text-white/50 font-bold">Board {match.board_number}</p>
        {isComplete ? <CheckCircle className="w-4 h-4 text-[#309F6A]" /> : isContinuous && <div className="w-2 h-2 rounded-full bg-[#E3292E] animate-pulse" />}
      </div>
      <div className="space-y-3">
        <TeamSlot
          name={match.team1_name}
          players={match.team1_players}
          isWinner={team1Won}
          canRecord={eventStatus === "active" && !team1Won}
          onWin={() => onRecordResult(match.id, match.team1_id)}
          testId={`${isContinuous ? "cont-" : ""}win-team1-match-${match.board_number}`}
        />
        <p className="text-center text-white/20 text-xs tracking-[0.3em] uppercase font-bold">VS</p>
        <TeamSlot
          name={match.team2_name}
          players={match.team2_players}
          isWinner={team2Won}
          canRecord={eventStatus === "active" && !team2Won}
          onWin={() => onRecordResult(match.id, match.team2_id)}
          testId={`${isContinuous ? "cont-" : ""}win-team2-match-${match.board_number}`}
        />
      </div>
      {isComplete && eventStatus === "active" && onOpenScoreDialog && (
        <button onClick={() => onOpenScoreDialog(match)} className="w-full mt-3 py-1.5 border border-white/10 text-white/40 hover:text-white hover:bg-white/5 text-xs tracking-wider uppercase font-bold transition-colors duration-200 text-center" data-testid={`${isContinuous ? "cont-" : ""}score-btn-${match.board_number}`}>
          {match.high_score || match.low_score || match.high_checkout ? "EDIT SCORES" : "ADD SCORES"}
        </button>
      )}
      {isContinuous && isComplete && eventStatus === "active" && onContinue && (
        <Button onClick={() => onContinue(match.id)} className="w-full mt-2 bg-[#E3292E] hover:bg-[#DC2626] text-white rounded-none text-xs font-heading font-bold" data-testid={`cont-continue-${match.board_number}`}>
          CONTINUE
        </Button>
      )}
      {(match.high_score || match.low_score || match.high_checkout) && (
        <div className="mt-2 space-y-0.5">
          {match.high_score && <p className="text-[#309F6A] text-[10px] font-body">High: {match.high_score.player} ({match.high_score.score})</p>}
          {match.high_checkout && <p className="text-yellow-400 text-[10px] font-body">Checkout: {match.high_checkout.player} ({match.high_checkout.score})</p>}
          {match.low_score && <p className="text-[#E3292E] text-[10px] font-body">Low: {match.low_score.player} ({match.low_score.score})</p>}
        </div>
      )}
    </div>
  );
}

function TeamSlot({ name, players, isWinner, canRecord, onWin, testId }) {
  return (
    <div className={`p-3 border transition-colors duration-200 ${isWinner ? "border-[#309F6A] bg-[#309F6A]/10" : "border-white/10"}`}>
      <p className={`font-heading font-bold ${isWinner ? "text-[#309F6A]" : "text-white"}`}>{name}</p>
      {players && players.includes("&") && <p className="text-white/40 text-xs mt-1 font-body">{players}</p>}
      {canRecord && (
        <Button onClick={onWin} size="sm" className="mt-2 rounded-none text-xs bg-[#309F6A] hover:bg-[#28875a] text-white" data-testid={testId}>
          <Trophy className="mr-1 h-3 w-3" /> WIN
        </Button>
      )}
      {isWinner && (
        <div className="flex items-center gap-1 mt-2">
          <Trophy className="w-4 h-4 text-[#309F6A]" />
          <span className="text-[#309F6A] text-xs font-bold tracking-wider">WINNER</span>
        </div>
      )}
    </div>
  );
}
